/**
 * Заменяет форматы jpeg/png в строке на webp.
 *
 * @param {string} str Строка с изображениями формата jpeg/png.
 * @return {string} Строка с изображениями формата webp.
 */
export default function(str) {
    return str.replace(/\.(jpe?g|png)/g, '.webp');
}
